<template>
  <v-row justify="space-around">
    <v-col cols="auto">
      <v-dialog v-model="showModal" max-width="600" persistent>
        <template>
          <v-card>
            <v-card-title> <v-row justify="center">Tipos de Impressões</v-row> </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />
                </v-col>
              </v-row>

              <v-row>
                <div class="grey--text text--darken-4 body-1 font-weight-black">• Adicione o nome da marca do produto dispensado logo abaixo:</div>
                <v-col cols="12">
                  <v-data-table v-if="!mostrarSkeleton" :headers="headers" :items="listaDeItensDisensa">
                    <template v-slot:top>
                      <v-toolbar flat color="white">
                        <v-toolbar-title>Produtos Dispensados</v-toolbar-title>
                        <v-spacer></v-spacer>
                      </v-toolbar>
                    </template>

                    <template v-slot:[`item.nomeItemImpressao`]="{ item }">
                      <div v-if="item.itemSistemaUnidade && item.itemSistemaUnidade.nomeItemSistema">{{ item.itemSistemaUnidade.nomeItemSistema }}</div>
                      <div v-else>{{ item.itemSistema.nomeItemSistema }}</div>
                    </template>

                    <template v-slot:[`item.marcaProduto`]="props">
                      <v-text-field style="max-width:300px" v-model="props.item.marcaProduto" :rules="[rules.requerido]" label="Marca do Produto" single-line></v-text-field>
                    </template>
                  </v-data-table>
                  
                  <v-skeleton-loader v-if="mostrarSkeleton">
                    <v-row>
                      <v-col cols="12" class="no-gutters pb-5">
                        <v-skeleton-loader type="heading"></v-skeleton-loader>
                      </v-col>
                    </v-row>

                    <v-row v-for="i in 6" :key="i">
                      <v-col cols="6" class="no-gutters pa-2">
                        <v-skeleton-loader type="text"></v-skeleton-loader>
                      </v-col>
                      <v-col cols="6" class="no-gutters pa-2">
                        <v-skeleton-loader type="text"></v-skeleton-loader>
                      </v-col>
                      <v-col cols="12" class="no-gutters pa-2">
                        <v-skeleton-loader type="divider"></v-skeleton-loader>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" class="no-gutters pa-0">
                        <v-skeleton-loader type="table-tfoot"></v-skeleton-loader>
                      </v-col>
                    </v-row>
                  </v-skeleton-loader>
                </v-col>
              </v-row>

              <v-row>
                <div class="grey--text text--darken-4 body-1 font-weight-black py-4">• Selecione abaixo o tipo de impressão que deseja utilizar:</div>
                <v-col cols="6" align="center" justify="center">
                  <v-card @click="gerarPDF" elevation="0" max-width="100">
                    <v-icon color="blue lighten-1" large>mdi-file-document</v-icon>
                    <div class="font-weight-medium blue--text text--lighten-1 pt-1">GERAR FOLHA</div>
                  </v-card>
                </v-col>

                <v-col cols="6" align="center" justify="center">
                  <v-card @click="imprimirCupom" elevation="0" max-width="100">
                    <v-icon color="blue lighten-1" large>mdi-text-box</v-icon>
                    <div class="font-weight-medium blue--text text--lighten-1 pt-1">GERAR CUPOM</div>
                  </v-card>
                </v-col>

                <!-- <v-col cols="4" align="center" justify="center">
                  <v-card @click="gerarNota" elevation="0" max-width="100">
                    <v-icon color="blue lighten-1" large>mdi-text-box</v-icon>
                    <div class="font-weight-medium blue--text text--lighten-1 pt-1">GERAR TICKET</div>
                  </v-card>
                </v-col>

                <v-col cols="4" align="center" justify="center">
                  <v-card @click="gerarComprovante" elevation="0" max-width="150">
                    <v-icon color="blue lighten-1" large>mdi-text-box</v-icon>
                    <div class="font-weight-medium blue--text text--lighten-1 pt-1">GERAR COMPROVANTE</div>
                  </v-card>
                </v-col> -->
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn @click="emitCloseModal" color="grey darken-4" text>Fechar</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import store from "@/store/index";
import axios from "../plugins/axios";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import Blob from "blob";

export default {
  components: {
    AlertaSnackbar,
  },

  props: {
    showModal: Boolean,
    dadosDispensa: Object,
    descricaoTela: String,
  },

  data: () => ({
    rules: {
      requerido: (value) => (value != null && value != "") || "Requer o campo!",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    headers: [
      {
        text: "Nome Marca",
        value: "marcaProduto",
      },
      {
        text: "Nome Produto",
        value: "nomeItemImpressao",
      },
    ],

    mostrarSkeleton: true,

    listaDeItensDisensa: [],

    attrs: {
      class: 'mb-6',
      boilerplate: true,
    },
  }),

  watch: {
    showModal() {
      if (this.showModal) {
        this.listarItensDispensa();
      }
    },
  },

  methods: {
    emitCloseModal() {
      this.$emit("close-modal");
    },

    async listarItensDispensa() {
      try {
        this.mostrarSkeleton = true;
        this.alertaSnackbar.mostrar = false;
        this.listaDeItensDisensa = [];

        if(this.descricaoTela == "DispensaPaciente") {
          const response = await axios.put("itensDispensadosPaciente", { numeroDispensaPaciente: this.dadosDispensa.dispensaPaciente.numeroDispensaPaciente }, this.config);
          this.listaDeItensDisensa = response.data;
          this.mostrarSkeleton = false;
        }

        if(this.descricaoTela == "DispensaSetor") {
          const response = await axios.put("itensDispensadosSetor", { numeroDispensaSetor: this.dadosDispensa.numeroDispensaSetor }, this.config);
          console.log(response.data)
          this.listaDeItensDisensa = response.data;
          this.mostrarSkeleton = false;
        }

      } catch (error) {
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    //#region GERAR PDF
    async gerarPDF() {
      let dataAtual = new Date().toISOString().substr(0, 10);
      let horasAtual = new Date();
      let formattedTime = new Intl.DateTimeFormat("default", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Sao_Paulo",
      }).format(horasAtual);

      var pdfMake = require("pdfmake/build/pdfmake.js");

      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      let numeroDispensa = null;
      if(this.descricaoTela == "DispensaPaciente") {
        numeroDispensa = this.dadosDispensa.dispensaPaciente.numeroDispensaPaciente;
      } else if(this.descricaoTela == "DispensaSetor") {
        numeroDispensa = this.dadosDispensa.numeroDispensaSetor;
      }

      var docDefinition = {
        info: {
          title: "Comprovante Entrega",
        },
        content: [
          { text: "Comprovante Entrega", style: "header" },
          {
            text: "Numero da Dispensa: " + numeroDispensa,
            style: "subheader",
          },
        ],
        styles: {
          header: {
            fontSize: 24,
            bold: true,
            alignment: "center",
            margin: [0, 32, 0, 8],
          },
          subheader: {
            fontSize: 16,
            bold: false,
            alignment: "center",
            margin: [0, 8, 0, 32],
          },
          textSignature: {
            fontSize: 16,
            bold: false,
            alignment: "center",
            margin: [0, 24, 0, 48],
          },
          bigSpace: {
            fontSize: 2,
            bold: false,
            alignment: "center",
            margin: [0, 200, 0, 8],
          },
          table: {
            alignment: "center",
            margin: [0, 32, 0, 56],
          },
          line: {
            alignment: "center",
            margin: [0, 2, 0, 2],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
          subtext: {
            fontSize: 14,
            bold: true,
            margin: [0, 24, 0, 4],
          },
          nameText: {
            margin: [0, 8, 0, 8],
            fontSize: 16,
          },
        },
        defaultStyle: {
          margin: [0, 1, 0, 1],
          fontSize: 12,
          // alignment: 'justify'
        },
      };

      if (this.listaDeItensDisensa.length > 0) {
        let tabela = [
          {
            style: "table",
            widths: ["*", "auto"],
            table: {
              headerRows: 1,
              body: [
                [
                  { text: "Número", style: "tableHeader" },
                  { text: "Lote", style: "tableHeader" },
                  { text: "Nome Item", style: "tableHeader" },
                  { text: "Validade", style: "tableHeader" },
                  { text: "Quantidade Dispensada", style: "tableHeader" },
                ],
              ],
            },
            layout: "lightHorizontalLines",
          },
        ];

        this.listaDeItensDisensa.map((itemSelecionado) => {
          const item = itemSelecionado.itemSistemaUnidade && itemSelecionado.itemSistemaUnidade.nomeItemSistema ? itemSelecionado.itemSistemaUnidade.nomeItemSistema : itemSelecionado.itemSistema.nomeItemSistema;
          const nomeItem = itemSelecionado.marcaProduto ? itemSelecionado.marcaProduto + " - " + item : item;

          if(this.descricaoTela == "DispensaSetor") {
            tabela[0].table.body.push([itemSelecionado.itemDispensa.numeroItemDispensa, itemSelecionado.item.lote, nomeItem, itemSelecionado.item.validade, itemSelecionado.itemDispensa.quantidadeDispensada]);
          } else if (this.descricaoTela == "DispensaPaciente") {
            tabela[0].table.body.push([itemSelecionado.itemDispensa.numeroItemDispensaPaciente, itemSelecionado.item.lote, nomeItem, itemSelecionado.item.validade, itemSelecionado.itemDispensa.quantidadeDispensada]);
          }
        });

        docDefinition.content.push(tabela);
      } else {
        let itens = { text: "Sem produtos dispensados!", style: "subtext" };
        docDefinition.content.push(itens);
      }

      docDefinition.content.push({
        text: "Recebi os Itens Constantes Neste Cupom",
        style: "textSignature",
      });
      docDefinition.content.push({
        canvas: [
          {
            type: "line",
            x1: 0,
            y1: 0,
            x2: 520,
            y2: 0,
            lineWidth: 1,
            style: "line",
          },
        ],
      });

      if(this.descricaoTela == "DispensaSetor") {
        docDefinition.content.push({ text: "Setor: " + this.dadosDispensa.nomeSetor, style: "nameText" },)
        if(this.dadosDispensa.funcionario.nomeFuncionario) {
          docDefinition.content.push({
            text: "Funcionario: " + this.dadosDispensa.funcionario.nomeFuncionario,
            style: "nameText",
          });
        }
      }

      if(this.descricaoTela == "DispensaPaciente") {
        if(this.dadosDispensa.paciente.descricaoNome) {
          docDefinition.content.push({
            text: "Beneficiario: " + this.dadosDispensa.paciente.descricaoNome,
            style: "nameText",
          });
        }
        
        if (this.dadosDispensa.paciente.descricaoEndereco) {
          docDefinition.content.push({
            text: "End.: " + this.dadosDispensa.paciente.descricaoEndereco,
          });
        }
        
        if (this.dadosDispensa.paciente.descricaoTelefone) {
          docDefinition.content.push({
            text: "Tel.: " + this.dadosDispensa.paciente.descricaoTelefone,
          });
        }
      }
      
      if (this.dadosDispensa.endereco.descricaoEndereco) {
        docDefinition.content.push({
          text: "End. Uni.: " + this.dadosDispensa.endereco.descricaoEndereco + ", " + this.dadosDispensa.endereco.descricaoNumeroIdentificador,
        });
      }
      if (this.dadosDispensa.endereco.descricaoBairro) {
        docDefinition.content.push({
          text: "Bairro: " + this.dadosDispensa.endereco.descricaoBairro,
        });
      }
      docDefinition.content.push({ text: "Municipio: Itu - SP" });
      if (this.dadosDispensa.endereco.descricaoCep) {
        docDefinition.content.push({
          text: "CEP: " + this.dadosDispensa.endereco.descricaoCep,
        });
      }
      docDefinition.content.push({
        text: "Data: " + this.formatarData(dataAtual) + " Hora: " + formattedTime,
      });

      pdfMake.createPdf(docDefinition).open();

      this.$emit("close-modal");
    },
    //#endregion

    //#region GERAR CUPOM
    imprimirCupom() {
      try {
        let dataAtual = new Date().toISOString().substr(0, 10);
        let horasAtual = new Date();
        let formattedTime = new Intl.DateTimeFormat("default", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZone: "America/Sao_Paulo",
        }).format(horasAtual);

        const workbook = new Workbook();

        // var borderStyles = {
        //   top: { style: "thin" },
        //   left: { style: "thin" },
        //   bottom: { style: "thin" },
        //   right: { style: "thin" },
        // };

        var worksheet = workbook.addWorksheet("Comprovante Entrega", {
          properties: { tabColor: { argb: "FF00FF00" } },
          views: [{ showGridLines: false }],
        });

        worksheet.columns = [
          { key: "col1", width: 50 }
        ];
        
        const regex = new RegExp('.{1,35}', 'g');

        let numeroDispensa = null;
        if(this.descricaoTela == "DispensaPaciente") {
          numeroDispensa = this.dadosDispensa.dispensaPaciente.numeroDispensaPaciente;
        } else if(this.descricaoTela == "DispensaSetor") {
          numeroDispensa = this.dadosDispensa.numeroDispensaSetor;
        }

        let posicaoLinha = 1;
        worksheet.getCell('A'+posicaoLinha).value = 'Comprovante Entrega';
        worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 7, bold: true };
        worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
        posicaoLinha++
        
        worksheet.getCell('A'+posicaoLinha).value = "Numero da Dispensa: " + numeroDispensa;
        worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 6, bold: false };
        worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
        posicaoLinha++
          
        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.getCell('A'+posicaoLinha).value = "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
        worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 6, bold: false };
        worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
        posicaoLinha++
        worksheet.getRow(posicaoLinha).height = 4;
        posicaoLinha++

        if(this.listaDeItensDisensa.length > 0) {
          worksheet.getCell('A'+posicaoLinha).value = "PRODUTO";
          worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 5 };
          worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
          posicaoLinha++
          
          this.listaDeItensDisensa.map((itemSelecionado) => {
            const item = itemSelecionado.itemSistemaUnidade && itemSelecionado.itemSistemaUnidade.nomeItemSistema ? itemSelecionado.itemSistemaUnidade.nomeItemSistema : itemSelecionado.itemSistema.nomeItemSistema;
            const nomeItem = itemSelecionado.marcaProduto ? itemSelecionado.marcaProduto + " - " + item : item;

            let titulo = "";
            if(this.descricaoTela == "DispensaSetor") {
              titulo = 'N. ' + itemSelecionado.itemDispensa.numeroItemDispensa + ' ' + nomeItem;
            } else if (this.descricaoTela == "DispensaPaciente") {
              titulo = 'N. ' + itemSelecionado.itemDispensa.numeroItemDispensaPaciente + ' ' + nomeItem;
            }

            const substrings = titulo.match(regex);

            substrings.forEach((substring, index) => {
              worksheet.getRow(posicaoLinha + index).height = 8;
              worksheet.getCell(`A${posicaoLinha + index}`).font = { name: 'Arial', family: 2, size: 5 };
              worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: 'middle', horizontal: 'left' };
              worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
            });
            posicaoLinha += substrings.length;
              
            worksheet.getRow(posicaoLinha).height = 8;
            worksheet.getCell('A'+posicaoLinha).value = 'Lote ' + itemSelecionado.item.lote;
            worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 5 };
            worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
            posicaoLinha++
            
            worksheet.getRow(posicaoLinha).height = 8;
            worksheet.getCell('A'+posicaoLinha).value = 'Validade ' + itemSelecionado.item.validade;
            worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 5 };
            worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
            posicaoLinha++
            
            worksheet.getRow(posicaoLinha).height = 8;
            worksheet.getCell('A'+posicaoLinha).value = 'QTDE. ' + itemSelecionado.itemDispensa.quantidadeDispensada;
            worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 5 };
            worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
            posicaoLinha++
            worksheet.getRow(posicaoLinha).height = 8;
            posicaoLinha++
            worksheet.getRow(posicaoLinha).height = 8;

          });
          posicaoLinha++
          worksheet.getRow(posicaoLinha).height = 8;
        } else {
          worksheet.getRow(posicaoLinha).height = 9;
          worksheet.getCell('A'+posicaoLinha).value = 'Sem produtos dispensados!';
          worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 6, bold: false };
          worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
          posicaoLinha++
          worksheet.getRow(posicaoLinha).height = 8;
          posicaoLinha++
          worksheet.getRow(posicaoLinha).height = 8;
        }
          
        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.getCell('A'+posicaoLinha).value = "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
        worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 6, bold: false };
        worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
        posicaoLinha++
        
        if(this.descricaoTela == "DispensaSetor") {
          const setor = "Setor: " + this.dadosDispensa.nomeSetor;
          const substringsSetor = setor.match(regex);

          substringsSetor.forEach((substring, index) => {
            worksheet.getRow(posicaoLinha + index).height = 9;
            worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
            worksheet.getCell(`A${posicaoLinha + index}`).font = { name: 'Arial', family: 2, size: 6, bold: false };
            worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: 'middle', horizontal: 'left' };
          });
          posicaoLinha += substringsSetor.length;

          if(this.dadosDispensa.funcionario.nomeFuncionario) {
            const benificiario = "Funcionario: " + this.dadosDispensa.funcionario.nomeFuncionario;
            const substringsBenificiario = benificiario.match(regex);
    
            substringsBenificiario.forEach((substring, index) => {
              worksheet.getRow(posicaoLinha + index).height = 9;
              worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
              worksheet.getCell(`A${posicaoLinha + index}`).font = { name: 'Arial', family: 2, size: 6, bold: false };
              worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: 'middle', horizontal: 'left' };
            });
            posicaoLinha += substringsBenificiario.length;
          }
        }
        
        if(this.descricaoTela == "DispensaPaciente") {
          if(this.dadosDispensa.paciente.descricaoNome) {
            const benificiario = "Beneficiario: " + this.dadosDispensa.paciente.descricaoNome;
            const substringsBenificiario = benificiario.match(regex);
    
            substringsBenificiario.forEach((substring, index) => {
              worksheet.getRow(posicaoLinha + index).height = 9;
              worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
              worksheet.getCell(`A${posicaoLinha + index}`).font = { name: 'Arial', family: 2, size: 6, bold: false };
              worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: 'middle', horizontal: 'left' };
            });
            posicaoLinha += substringsBenificiario.length;
          }
          
          if(this.dadosDispensa.paciente.descricaoEndereco) {
            const enderecoPaciente = "End.: " + this.dadosDispensa.paciente.descricaoEndereco;
            const substringsEnderecoPaciente = enderecoPaciente.match(regex);
    
            substringsEnderecoPaciente.forEach((substring, index) => {
              worksheet.getRow(posicaoLinha + index).height = 9;
              worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
              worksheet.getCell(`A${posicaoLinha + index}`).font = { name: 'Arial', family: 2, size: 6, bold: false };
              worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: 'middle', horizontal: 'left' };
            });
            posicaoLinha += substringsEnderecoPaciente.length;
          }

          if(this.dadosDispensa.paciente.descricaoTelefone) {
            worksheet.getRow(posicaoLinha).height = 9;
            worksheet.getCell('A'+posicaoLinha).value = "Tel.: " + this.dadosDispensa.paciente.descricaoTelefone;
            worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 6, bold: false };
            worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
            posicaoLinha++
          }
        }
        
        worksheet.getRow(posicaoLinha).height = 8;
        posicaoLinha++
        
        if (this.dadosDispensa.endereco.descricaoEndereco) {
          const endereco = "End. Uni.: " + this.dadosDispensa.endereco.descricaoEndereco;
          const substringsEndereco = endereco.match(regex);

          substringsEndereco.forEach((substring, index) => {
            worksheet.getRow(posicaoLinha + index).height = 9;
            worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
            worksheet.getCell(`A${posicaoLinha + index}`).font = { name: 'Arial', family: 2, size: 6, bold: false };
            worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: 'middle', horizontal: 'left' };
          });
          posicaoLinha += substringsEndereco.length;
        }
        
        if (this.dadosDispensa.endereco.descricaoBairro) {
          const bairro = "Bairro: " + this.dadosDispensa.endereco.descricaoBairro;
          const substringsBairro = bairro.match(regex);

          substringsBairro.forEach((substring, index) => {
            worksheet.getRow(posicaoLinha + index).height = 9;
            worksheet.getCell(`A${posicaoLinha + index}`).value = substring;
            worksheet.getCell(`A${posicaoLinha + index}`).font = { name: 'Arial', family: 2, size: 6, bold: false };
            worksheet.getCell(`A${posicaoLinha + index}`).alignment = { vertical: 'middle', horizontal: 'left' };
          });
          posicaoLinha += substringsBairro.length;
        }

        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.getCell('A'+posicaoLinha).value = "Municipio: Itu - SP";
        worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 6, bold: false };
        worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
        posicaoLinha++
        
        if (this.dadosDispensa.endereco.descricaoCep) {
          worksheet.getRow(posicaoLinha).height = 9;
          worksheet.getCell('A'+posicaoLinha).value = "CEP: " + this.dadosDispensa.endereco.descricaoCep;
          worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 6, bold: false };
          worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
          posicaoLinha++
        }

        worksheet.getRow(posicaoLinha).height = 9;
        worksheet.getCell('A'+posicaoLinha).value = "Data: " + this.formatarData(dataAtual) + " Hora: " + formattedTime;
        worksheet.getCell('A'+posicaoLinha).font = { name: 'Arial', family: 2, size: 6, bold: false };
        worksheet.getCell('A'+posicaoLinha).alignment = { vertical: 'middle', horizontal: 'left' };
        posicaoLinha++

        // worksheet.eachRow({ includeEmpty: true }, function(row) {
        //   row.eachCell({ includeEmpty: true }, function(cell) {
        //     cell.border = borderStyles;
        //   });
        // });

        workbook.xlsx.writeBuffer().then(function(data) {
          var blob = new Blob([data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Comprovante Entrega.xlsx");
        });

        this.$emit("close-modal");
      } catch (error) {
        console.log(error);
      }
    },
    //#endregion

    //#region GERAR NOTA
    async gerarNota() {
      let gerarRelatorio = true;
      this.listaDeItensDisensa.map((itemSelecionado) => {
        if (!itemSelecionado.marcaProduto) {
          this.alertaSnackbar.texto = "Não foi possível continuar, pois ainda existem produtos sem o nome da marca.";
          this.alertaSnackbar.mostrar = true;
          gerarRelatorio = false;
        }
      });

      if (gerarRelatorio) {
        let dataAtual = new Date().toISOString().substr(0, 10);
        let horasAtual = new Date();
        let formattedTime = new Intl.DateTimeFormat("default", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZone: "America/Sao_Paulo",
        }).format(horasAtual);

        var pdfMake = require("pdfmake/build/pdfmake.js");

        if (pdfMake.vfs == undefined) {
          var pdfFonts = require("pdfmake/build/vfs_fonts.js");
          pdfMake.vfs = pdfFonts.pdfMake.vfs;
        }

        var docDefinition = {
          pageOrientation: "landscape",
          info: {
            title: "Comprovante Entrega",
          },
          content: [
            { text: "Comprovante Entrega", style: "header" },
            {
              text: "Numero da Dispensa: " + this.dadosDispensa.dispensaPaciente.numeroDispensaPaciente,
              style: "subheader",
            },
          ],
          styles: {
            header: {
              fontSize: 42,
              bold: true,
              alignment: "center",
              margin: [0, 32, 0, 8],
            },
            subheader: {
              fontSize: 32,
              bold: false,
              alignment: "center",
              margin: [0, 8, 0, 32],
            },
            textSignature: {
              fontSize: 28,
              bold: false,
              alignment: "center",
              margin: [0, 24, 0, 96],
            },
            bigSpace: {
              fontSize: 2,
              bold: false,
              alignment: "center",
              margin: [0, 200, 0, 8],
            },
            table: {
              alignment: "center",
              margin: [0, 56, 0, 56],
            },
            line: {
              alignment: "center",
              margin: [0, 2, 0, 2],
            },
            tableHeader: {
              bold: true,
              fontSize: 22,
              color: "black",
            },
            subtext: {
              fontSize: 28,
              bold: true,
              margin: [0, 24, 0, 4],
            },
            nameText: {
              margin: [0, 16, 0, 16],
              fontSize: 28,
            },
          },
          defaultStyle: {
            margin: [0, 1, 0, 1],
            fontSize: 28,
            // alignment: 'justify'
          },
        };

        if (this.listaDeItensDisensa.length > 0) {
          let tabela = [
            {
              style: "table",
              widths: ["*", "auto"],
              table: {
                headerRows: 1,
                body: [
                  [
                    { text: "Número", style: "tableHeader" },
                    { text: "Lote", style: "tableHeader" },
                    { text: "Nome Item", style: "tableHeader" },
                    { text: "Validade", style: "tableHeader" },
                    { text: "Quantidade Dispensada", style: "tableHeader" },
                  ],
                ],
              },
              layout: "lightHorizontalLines",
            },
          ];

          for (let item of this.listaDeItensDisensa) {
            tabela[0].table.body.push([item.itemDispensa.numeroItemDispensaPaciente, item.item.lote, item.itemSistema.nomeItemSistema, item.item.validade, item.itemDispensa.quantidadeDispensada]);
          }

          this.listaDeItensDisensa.map((itemSelecionado) => {
            const nomeItem = itemSelecionado.marcaProduto + " - " + itemSelecionado.itemSistema.nomeItemSistema;

            tabela[0].table.body.push([itemSelecionado.itemDispensa.numeroItemDispensaPaciente, itemSelecionado.item.lote, nomeItem, itemSelecionado.item.validade, itemSelecionado.itemDispensa.quantidadeDispensada]);
          });

          docDefinition.content.push(tabela);
        } else {
          let itens = { text: "Sem produtos dispensados!", style: "subtext" };
          docDefinition.content.push(itens);
        }

        docDefinition.content.push({
          text: "Recebi os Itens Constantes Neste Cupom",
          style: "textSignature",
        });
        docDefinition.content.push({
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 760,
              y2: 0,
              lineWidth: 1,
              style: "line",
            },
          ],
        });
        docDefinition.content.push({
          text: "Beneficiario: " + this.dadosDispensa.paciente.descricaoNome,
          style: "nameText",
        });
        if (this.dadosDispensa.endereco.descricaoEndereco) {
          docDefinition.content.push({
            text: "End.: " + this.dadosDispensa.endereco.descricaoEndereco + ", " + this.dadosDispensa.endereco.descricaoNumeroIdentificador,
          });
        }
        if (this.dadosDispensa.endereco.descricaoBairro) {
          docDefinition.content.push({
            text: "Bairro: " + this.dadosDispensa.endereco.descricaoBairro,
          });
        }
        docDefinition.content.push({ text: "Municipio: Itu - SP" });
        if (this.dadosDispensa.endereco.descricaoCep) {
          docDefinition.content.push({
            text: "CEP: " + this.dadosDispensa.endereco.descricaoCep,
          });
        }
        docDefinition.content.push({
          text: "Data: " + this.formatarData(dataAtual) + " Hora: " + formattedTime,
        });
        docDefinition.content.push({ text: ".", style: "bigSpace" });

        pdfMake.createPdf(docDefinition).open();

        this.$emit("close-modal");
      }
    },
    //#endregion

    //#region GERAR COMPROVANTE
    async gerarComprovante() {
      let gerarRelatorio = true;
      this.listaDeItensDisensa.map((itemSelecionado) => {
        if (!itemSelecionado.marcaProduto) {
          this.alertaSnackbar.texto = "Não foi possível continuar, pois ainda existem produtos sem o nome da marca.";
          this.alertaSnackbar.mostrar = true;
          gerarRelatorio = false;
        }
      });

      if (gerarRelatorio) {
        let dataAtual = new Date().toISOString().substr(0, 10);
        let horasAtual = new Date();
        let formattedTime = new Intl.DateTimeFormat("default", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZone: "America/Sao_Paulo",
        }).format(horasAtual);

        var pdfMake = require("pdfmake/build/pdfmake.js");

        if (pdfMake.vfs == undefined) {
          var pdfFonts = require("pdfmake/build/vfs_fonts.js");
          pdfMake.vfs = pdfFonts.pdfMake.vfs;
        }

        var docDefinition = {
          info: {
            title: "Comprovante Entrega",
          },
          content: [
            { text: "Comprovante Entrega", style: "header" },
            {
              text: "Numero da Dispensa: " + this.dadosDispensa.dispensaPaciente.numeroDispensaPaciente,
              style: "subheader",
            },
            {
              text: "-----------------------------------------------",
              style: "subheader",
            },
          ],
          styles: {
            header: {
              fontSize: 14,
              bold: true,
              alignment: "center",
              margin: [0, 32, 0, 8],
            },
            subheader: {
              fontSize: 14,
              bold: false,
              alignment: "center",
              margin: [0, 8, 0, 32],
            },
            textSignature: {
              fontSize: 14,
              bold: false,
              alignment: "center",
              margin: [0, 24, 0, 48],
            },
            bigSpace: {
              fontSize: 2,
              bold: false,
              alignment: "center",
              margin: [0, 200, 0, 8],
            },
            table: {
              alignment: "center",
              margin: [0, 32, 0, 56],
            },
            line: {
              alignment: "center",
              margin: [0, 2, 0, 2],
            },
            tableHeader: {
              bold: true,
              fontSize: 13,
              color: "black",
            },
            subtext: {
              fontSize: 14,
              bold: true,
              margin: [0, 24, 0, 4],
            },
            nameText: {
              margin: [0, 8, 0, 8],
              fontSize: 14,
            },
          },
          defaultStyle: {
            margin: [0, 1, 0, 1],
            fontSize: 12,
            // alignment: 'justify'
          },
        };

        if (this.listaDeItensDisensa.length > 0) {
          let tabela = [
            {
              style: "table",
              widths: ["*", "auto"],
              table: {
                headerRows: 1,
                body: [
                  [
                    { text: "", style: "tableHeader" },
                    { text: "", style: "tableHeader" },
                    { text: "", style: "tableHeader" },
                    { text: "", style: "tableHeader" },
                    { text: "", style: "tableHeader" },
                    { text: "", style: "tableHeader" },
                    { text: "", style: "tableHeader" },
                  ],
                ],
              },
              layout: "lightHorizontalLines",
            },
          ];

          this.listaDeItensDisensa.map((itemSelecionado) => {
            const nomeItem = itemSelecionado.marcaProduto + " - " + itemSelecionado.itemSistema.nomeItemSistema;

            tabela[0].table.body.push([
              "-  ",
              "Numero:" + itemSelecionado.itemDispensa.numeroItemDispensaPaciente + "  ",
              "Lote:" + itemSelecionado.item.lote + "  ",
              "Nome:" + nomeItem + "  ",
              "Validade:" + itemSelecionado.item.validade + "  ",
              "Qtde:" + itemSelecionado.itemDispensa.quantidadeDispensada + "  ",
              "-----------------------------------------------",
            ]);
          });
          docDefinition.content.push(tabela);
        } else {
          let itens = { text: "Sem produtos dispensados!", style: "subtext" };
          docDefinition.content.push(itens);
        }

        docDefinition.content.push({
          text: "-----------------------------------------------",
          style: "textSignature",
        });
        docDefinition.content.push({
          text: "Recebi os Itens Constantes Neste Cupom",
          style: "textSignature",
        });
        docDefinition.content.push({
          text: "Beneficiario: " + this.dadosDispensa.paciente.descricaoNome,
          style: "nameText",
        });
        if (this.dadosDispensa.endereco.descricaoEndereco) {
          docDefinition.content.push({
            text: "End.: " + this.dadosDispensa.endereco.descricaoEndereco + ", " + this.dadosDispensa.endereco.descricaoNumeroIdentificador,
          });
        }

        if (this.dadosDispensa.endereco.descricaoBairro) {
          docDefinition.content.push({ text: "Bairro: " + this.dadosDispensa.endereco.descricaoBairro });
        }

        docDefinition.content.push({ text: "Municipio: Itu - SP" });

        if (this.dadosDispensa.endereco.descricaoCep) {
          docDefinition.content.push({ text: "CEP: " + this.dadosDispensa.endereco.descricaoCep });
        }

        docDefinition.content.push({ text: "Data: " + this.formatarData(dataAtual) + " Hora: " + formattedTime });

        pdfMake.createPdf(docDefinition).open();

        this.$emit("close-modal");
      }
    },
    //#endregion

    //#region FORMATADORES
    formatarData(data) {
      if (!data) return null;
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },
    //#endregion
  },
};
</script>
